import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseQueryResult,
  type UseMutationResult,
} from "@tanstack/react-query";
import { api, type OrgContext, type OrgContextResponse } from "@/lib/api";

export const orgContextKey = ["org-context"] as const;

export function useOrgContext(): UseQueryResult<OrgContextResponse> {
  return useQuery({
    queryKey: orgContextKey,
    queryFn: () => api.getOrgContext(),
  });
}

/**
 * NOTE: this hook intentionally does NOT toast on success. Pages that use
 * autosave have their own inline "Saving / Saved" indicator; toasting on
 * every keystroke would be noisy. Pages can still surface errors via their
 * own error UI.
 */
export function useUpdateOrgContext(): UseMutationResult<OrgContext, Error, Partial<OrgContext>> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Partial<OrgContext>) => api.updateOrgContext(body),
    onSuccess() {
      qc.invalidateQueries({ queryKey: orgContextKey });
    },
  });
}
